<div class="container">
  <div class="page-index" (click)="onClickPrevious()" [class.disabled]="currentPageIndex === start">&laquo;</div>
  @if (pageIndexes.length < maxItemSize * 2) {
    @for (pageIndex of pageIndexes; track pageIndex) {
      <div class="page-index" [class.active]="currentPageIndex === pageIndex" (click)="onClickPageIndex(pageIndex)">
        {{ pageIndex }}
      </div>
    }
  } @else {
    @if (currentPageIndex > 0 && currentPageIndex <= maxItemSize) {
      @for (pageIndex of pageIndexes.slice(0, maxItemSize); track pageIndex) {
        <div class="page-index" [class.active]="currentPageIndex === pageIndex" (click)="onClickPageIndex(pageIndex)">
          {{ pageIndex }}
        </div>
      }
      <div class="page-index disabled">...</div>
      <div class="page-index" (click)="onClickPageIndex(end)">{{ end }}</div>
    }
    @if (currentPageIndex > end - maxItemSize && currentPageIndex <= end) {
      <div class="page-index" (click)="onClickPageIndex(start)">{{ start }}</div>
      <div class="page-index disabled">...</div>
      @for (pageIndex of pageIndexes.slice(pageIndexes.length - maxItemSize, pageIndexes.length); track pageIndex) {
        <div class="page-index" [class.active]="currentPageIndex === pageIndex" (click)="onClickPageIndex(pageIndex)">
          {{ pageIndex }}
        </div>
      }
    }
    @if (currentPageIndex > maxItemSize && currentPageIndex <= end - maxItemSize) {
      <div class="page-index" (click)="onClickPageIndex(start)">{{ start }}</div>
      <div class="page-index disabled">...</div>
      @for (
        pageIndex of pageIndexes.slice(currentPageIndex - centralIndexesSize, currentPageIndex + centralIndexesSize);
        track pageIndex
      ) {
        <div class="page-index" [class.active]="currentPageIndex === pageIndex" (click)="onClickPageIndex(pageIndex)">
          {{ pageIndex }}
        </div>
      }
      <div class="page-index disabled">...</div>
      <div class="page-index" (click)="onClickPageIndex(end)">{{ end }}</div>
    }
  }
  <div class="page-index" (click)="onClickNext()" [class.disabled]="currentPageIndex === end">&raquo;</div>
</div>
